import { Route } from '@angular/router';
import { provideHome, HomeService } from '@bodyanalytics/front/shared/home/domain';
import { FrontSharedHomeFeatureComponent } from './front-shared-home-feature.component';

export const homeUiRoutes: Route = {
  path: 'home',
  component: FrontSharedHomeFeatureComponent,
  providers: [provideHome(), HomeService],
};
